var render = function render(){var _vm=this,_c=_vm._self._c;return _c('channel-form',{attrs:{"title":"创建分割频道","spacer":"","channel":_vm.channel},on:{"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }